module.exports = __webpack_public_path__ + "static/media/6.120b4a02.jpg";